import React, { useState } from 'react';
import { InputLabel, Typography } from '@mui/material';
import { useField } from 'formik';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cx } from '../../../helpers/global';
import './style.css';

interface Props {
  name: string;
  label: string;
  placeholder: string | undefined;
  disabled: boolean;
}

export default function StyledPhoneInput({
  name,
  label,
  placeholder,
  disabled,
}: Props) {
  const [{ value: phoneNumber }, { error, touched }, { setValue, setTouched }] =
    useField(name);

  const [valueSet, setValueSet] = useState(false);

  const onBlur = React.useCallback(() => {
    setTouched(true);
  }, [setTouched]);

  const isError = touched && !!error;

  return (
    <div
      className={cx('input', 'phone-input', isError && 'error')}
      style={{ position: 'relative' }}>
      <InputLabel htmlFor={name}>
        <Typography variant="h5">{label}</Typography>
      </InputLabel>
      <PhoneInput
        placeholder={placeholder}
        country="us"
        value={phoneNumber}
        onChange={val => {
          const cleanedVal = val.replace(/\D/g, '');
          setValue(cleanedVal);
          setValueSet(true);
        }}
        disabled={disabled}
        disableDropdown={disabled}
        onBlur={onBlur}
      />
      {!phoneNumber && !valueSet && (
        <Typography
          variant="body2"
          color="text.tertiary"
          className="phone-number-placeholder"
          style={{
            position: 'absolute',
            top: 17,
            left: 260,
          }}>
          Phone Number
        </Typography>
      )}
    </div>
  );
}
